import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles({
	iconContainer: {
		width: 60,
		height: 60,
		borderRadius: "100%"
	},
	iconStyle: {
		height: 19
	},
	dataContainer: {
		minHeight: 160
	},
	count: {
		height: 27,
		fontWeight: "bold",
		fontSize: 36
	}
})

export default useStyles
